import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { AnyInnerSection, Section, SectionAttributes } from '../../types/section';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';
import { VisualFigureComponent, VisualFigureSection } from '../../components/visual-figure/visual-figure.component';

export interface MediumSectionAttributes extends SectionAttributes {
  numColumns: 12 | 8 | 4;
  medium: VisualFigureSection;
  headline?: string;
}

type MediumSectionEditorIds = [
  'medium',
  'headline',
  'numColumns',
];

export type MediumSection = Section<MediumSectionAttributes, MediumSectionEditorIds, 'medium'>;

export function isMediumSection(section: AnyInnerSection): section is MediumSection {
  return section.component === 'medium';
}

@Component({
    selector: 'app-medium',
    styleUrls: ['./medium.component.scss'],
    templateUrl: './medium.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        FsButtonComponent,
        VisualFigureComponent,
    ],
})
export class MediumComponent extends SectionComponent<MediumSection> implements OnInit {

}
